// Libs
import React from 'react'
import styled, { css } from 'styled-components'

// Comps
import { colors, mobileScreen } from '../../utils'

export const Div = styled.div`
  /* cursor: pointer; */
  display: flex;
  flex-wrap: wrap;
`

// Page.
export const descoverPageStyles = css`
  .BowedHero {
    margin-bottom: 75px;

    ${mobileScreen(
      css`
        margin-bottom: 60px;
      `,
    )}
  }

  .FunctionBar {
    margin-bottom: 60px;
    ${mobileScreen(
      css`
        margin-bottom: 60px;
      `,
    )}
  }

  div.body {
    width: 1000px;
    max-width: 100%;
    margin: auto;
    box-sizing: border-box;
    /* padding-top: 60px; */
  }

  .loadMore {
    margin: auto;
    margin-top: 82px;
    margin-bottom: 100px;
    height: 18px;
    display: flex;

    .arrowDown {
      width: 18px;
      height: 18px;
      margin-left: 8.7px;
    }

    & > .content {
      justify-content: center;
      align-items: center;
      display: flex;
    }
  }

  .buttonLink {
    color: ${colors.purple};
    display: flex;
  }

  .callout {
    color: ${colors.purple};
  }

  .linkContainer {
    cursor: pointer;
    display: flex;
  }

  .loadMoreButton {
    display: flex;
    cursor: pointer;
    color: ${colors.purple};
    border: none;
    background-color: ${colors.white};
  }

  .EventItemList {
    margin: auto;
  }

  .ctaBanner {
    margin-top: 60px;
    width: -moz-available;
    width: -webkit-fill-available;
    width: fill-available;
  }
`
